
import { environment } from './../environments/environment';

let endPointUrl = '';

if (environment.envName == 'prod') {
    endPointUrl = 'https://fordconnect.hartehanks.com';
} else if (environment.envName == 'stage1') {
    endPointUrl = 'https://fordconnecttest.hartehanks.com';
} else if (environment.envName == 'stage2') {
    endPointUrl = 'https://fordconnecttest.hartehanks.com';
} else {
    // dev
    endPointUrl = 'http://localhost:8080';
}



export const GlobalVariable = Object.freeze({
     FORDAPIEndPointURL:endPointUrl
 });

 export const ExportAvailability = Object.freeze({
   //If export value is true ,Export functionality will be available for all modules.
   export : true
 });



// WEBPACK FOOTER //
// ./src/app/config.ts